export enum newsEnum {
	actualite_exploitation = 'actualite_exploitation',
	actualite_marketing = 'actualite_marketing'
}
